const actions = {
  SET_STATE: 'user/SET_STATE',
  LOGIN: 'user/LOGIN',
  LOAD_CURRENT_ACCOUNT: 'user/LOAD_CURRENT_ACCOUNT',
  UPDATE_PASSWORD: 'user/UPDATE_PASSWORD',
  LOGOUT: 'user/LOGOUT',
  REST_PASSWORD: 'user/REST_PASSWORD'
}

export default actions
